import QuotationError from './QuotationError';
class QuotationEnoughPropertyBricks extends QuotationError {
    constructor(options) {
        super('The crowdfunding property does not have enough available bricks', options);
    }
}
export default QuotationEnoughPropertyBricks;
